var _defs, _g, _g2, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoefTempFereastraWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a58eb51a-5403-4f33-86e1-cfde1f5b0a01",
    "data-name": "coef_temp_fereastra",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a338567c-6184-4cbd-82fd-48401308e664,.a3ef9088-995b-4865-b16f-12ce1a6c518b,.b791a58d-0106-4cb4-a197-13240dd0a2f8,.b9b42ad8-b27a-45e1-938b-777be7b5348b,.bb999138-fea4-4730-b2cf-ede368542b34{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.bb999138-fea4-4730-b2cf-ede368542b34{stroke-width:8px;}.b53ec334-10a9-4472-bc38-7b291e424b89{fill:#fff;}.a338567c-6184-4cbd-82fd-48401308e664{stroke-width:3px;}.b791a58d-0106-4cb4-a197-13240dd0a2f8{stroke-width:6px;}.b9b42ad8-b27a-45e1-938b-777be7b5348b{stroke-width:10px;}.a3ef9088-995b-4865-b16f-12ce1a6c518b{stroke-width:5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coef_temp_fereastra_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f1787ca0-1574-4dd8-81c1-c0cb1efdee81",
    "data-name": "termostat copy 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bb999138-fea4-4730-b2cf-ede368542b34",
    d: "M35.41,161.06a19.5,19.5,0,1,1-23.85,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "bb999138-fea4-4730-b2cf-ede368542b34",
    x1: 12,
    y1: 160,
    x2: 12,
    y2: 117
  }), /*#__PURE__*/React.createElement("line", {
    className: "bb999138-fea4-4730-b2cf-ede368542b34",
    x1: 35,
    y1: 160,
    x2: 35,
    y2: 117
  }), /*#__PURE__*/React.createElement("path", {
    className: "bb999138-fea4-4730-b2cf-ede368542b34",
    d: "M12,117.17a11.5,11.5,0,0,1,23,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b53ec334-10a9-4472-bc38-7b291e424b89",
    cx: 24,
    cy: 176.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "a338567c-6184-4cbd-82fd-48401308e664",
    x1: 35.42,
    y1: 127.46,
    x2: 30.54,
    y2: 127.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "a338567c-6184-4cbd-82fd-48401308e664",
    x1: 35.5,
    y1: 133.5,
    x2: 30.5,
    y2: 133.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "a338567c-6184-4cbd-82fd-48401308e664",
    x1: 35.5,
    y1: 139.5,
    x2: 30.5,
    y2: 139.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "b791a58d-0106-4cb4-a197-13240dd0a2f8",
    x1: 24,
    y1: 175,
    x2: 24,
    y2: 131
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "e701626b-69e0-41ab-8ece-c7fd7cdefedc",
    "data-name": "fereastra copy"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "b9b42ad8-b27a-45e1-938b-777be7b5348b",
    points: "24 104.49 24 5 195 5 195 176 44.87 176"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b9b42ad8-b27a-45e1-938b-777be7b5348b",
    x: 49.52,
    y: 27.69,
    width: 119.96,
    height: 125.62
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a3ef9088-995b-4865-b16f-12ce1a6c518b",
    x1: 137,
    y1: 41,
    x2: 158.5,
    y2: 62.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a3ef9088-995b-4865-b16f-12ce1a6c518b",
    x1: 111,
    y1: 42,
    x2: 157.5,
    y2: 88.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoefTempFereastraWhite);
export default __webpack_public_path__ + "static/media/coef_temp_fereastra_white.4a6df2c1b3063b219e2667a894c1fbe4.svg";
export { ForwardRef as ReactComponent };